<template>
  <div class="debit-card-page debit-card-wrapper bg-white">
    <Head>
      <Title>{{ $messages('features-debit-card-atms.meta.title') }}</Title>
      <Meta hid="og:image" property="og:image" :content="ogImage" />
    </Head>
    <BlocksNewServiceHero
      v-bind="hero"
      :show-widget="false"
    />

    <BlocksContentBox
      :tagline="$messages('features-debit-card-atms.no_fees_content_box.tagline')"
      :title="$messages('features-debit-card-atms.no_fees_content_box.title')"
      :body="$messages('features-debit-card-atms.no_fees_content_box.body')"
      :cta="$messages('features-debit-card-atms.no_fees_content_box.cta')"
      @action="scrollToCheckout"
    >
      <template #visual>
        <BlocksContentBoxIconCanvasAsset :label="$messages('features-debit-card-atms.no_fees_content_box.canvas')" service="card" bg-class="bg-coffee" />
      </template>
    </BlocksContentBox>

    <BlocksContentBox
      :tagline="$messages('features-debit-card-atms.free_withdraw_content_box.tagline')"
      :title="$messages('features-debit-card-atms.free_withdraw_content_box.title')"
      :body="$messages('features-debit-card-atms.free_withdraw_content_box.body')"
      :cta="$messages('features-debit-card-atms.free_withdraw_content_box.cta')"
      bg-class="bg-light-green"
      bg-animation="circle"
      @action="scrollToCheckout"
    />

    <BlocksContentBox
      :tagline="$messages('features-debit-card-atms.surcharge_free_content_box.tagline')"
      :title="$messages('features-debit-card-atms.surcharge_free_content_box.title')"
      :body="$messages('features-debit-card-atms.surcharge_free_content_box.body')"
    >
      <template #visual>
        <BlocksContentBoxAppScreenAsset screen-image="https://majority.imgix.net/web-assets/stills/atm-map-still.png" />
      </template>
    </BlocksContentBox>

    <BlocksUserReviewList />

    <BlocksFaqV2
      v-bind="$messages('faq')"
    />

    <BlocksMiniCheckout ref="checkout" />
  </div>
</template>

<script>
import { optimize } from '@/utils/image-optimization'
import PageMixing from '@/mixins/page-mixin'

export default {
  name: 'DebitCard',
  layout: 'default',
  mixins: [PageMixing('features-debit-card-atms', 'Features - Debit Visa Card Atms', 'features-debit-card-atms.meta.title')],
  data () {
    return {
      hero: {
        fullScreenImage: false,
        backgroundColor: {
          hex: '#fff5f0'
        },
        imageBackgroundColor: {
          hex: ''
        },
        image: {
          url: 'https://majority.imgix.net/web-assets/stills/atm-map-device.png',
          alt: 'ATMs map'
        },
        title: this.$messages('features-debit-card-atms.hero.title'),
        titleColor: {
          hex: '#000000'
        },
        bodyText: this.$messages('features-debit-card-atms.hero.body'),
        bodyTextColor: {
          hex: '#000000'
        },
        primaryCta: [
          {
            buttonType: 'sign-up',
            outline: 'none',
            buttonColor: {
              hex: '#000000'
            },
            textColor: {
              hex: '#FFFFFF'
            },
            buttonText: this.$messages('features-debit-card-atms.hero.cta')
          }
        ]
      },
      cta: this.$messages('features-debit-card-atms.hero.cta'),
      breadcrumbs: [
        {
          title: this.$messages('label.home'),
          to: this.$mRouter.getLocalRoute({ name: 'index' })
        },
        {
          title: this.$messages('page_labels.debit_card'),
          to: this.$mRouter.getLocalRoute({ name: 'visa-debit-card' })
        },
        {
          title: this.$messages('features-debit-card-atms.hero.title')
        }
      ]
    }
  },
  computed: {
    ogImage () {
      return optimize(
        'https://majority.imgix.net/web-assets/meta/og.png',
        false,
        { w: 1200, h: 630, fit: 'fill', fill: 'solid', 'fill-color': '283A35' }
      )
    }
  },
  methods: {
    onCtaHeroClick () {
      this.scrollToCheckout()
      this.$track.linkClicked('debitCardAtmsHeroButton', 'cta', { linkText: 'scroll-to-checkout' })
    },
    scrollToCheckout () {
      this.$refs.checkout.$el.querySelector('#mini-checkout-form').scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
  }
}
</script>

  <style lang="postcss" scoped>
  </style>
